// Önce gelmeli: eski Android verisini diğer modüller depoyu okumadan taşır.
import { redirectingForMigration } from "./lib/nativeMigrationBoot.ts";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { registerSW } from "virtual:pwa-register";
import App from "./App.tsx";
import { captureAppDistribution } from "./lib/distribution.ts";
import { applyStoredTheme } from "./lib/theme.ts";
import { installNativeExternalLinks } from "./lib/externalLinks.ts";
import "./index.css";

applyStoredTheme();
captureAppDistribution();
installNativeExternalLinks();

// Yeni sürüm çıktığında sessizce güncellenir; oyuncu bir şey yapmak zorunda değil.
// Android uygulaması da arayüzü siteden yüklediği için çevrimdışı oyun bu önbelleğe dayanıyor.
if (!redirectingForMigration) registerSW({ immediate: true });

const root = document.getElementById("root");
if (!root) throw new Error("#root was not found");

if (!redirectingForMigration) {
  createRoot(root).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
}
